<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        label-width="160px"
        @cancle="cancleHandler"
        @submit="submitHandler"
        >

            <el-form-item
            class="table-full-row"
            label="标段名称"
            prop="bdcodes"
            :rules="newRule('标段名称', 'required')">
                <cascader-bid
                    v-model="form.bdcodes"
                    2way="name"
                    :name.sync="form.bdnames"
                    :zbprocode="form.zbprocode"
                ></cascader-bid>
            </el-form-item>

            <el-form-item
            label="评审开始时间"
            prop="pstime"
            :rules="newRule('评审开始时间', 'required')">
                <el-date-picker
                v-model="form.pstime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item
            label="评委会人数"
            prop="shuliang"
            :rules="newRule('评委会人数', 'required')">
                <el-input-number
                    v-model="form.shuliang">
                </el-input-number>
            </el-form-item>

             <el-form-item
            label="是否统一专家库抽取"
            prop="typbzjk" v-if="isnzk===false"
            :rules="newRule('专家库', 'required')"
            >
                <my-radio
                    v-model="form.typbzjk"
                    :data="[{key:'1', value:'是'}, {key:'0', value:'否'}]">
                </my-radio>
            </el-form-item>
            <!-- v-if="isnzk===true"-->
            <el-form-item
            label="专家库"
            prop="typbzjk" class="table-full-row"
            :rules="newRule('专家库', 'required')">
                <my-radio
                    v-model="form.typbzjk"
                    :data="[{key:'1', value:'河北省统一专家库'}, {key:'2', value:`${ptPlaceholder}企业自主招标采购抽取系统（“${ptPlaceholder}专家库”或“招标代理专家库”）`}, {key:'0', value:'自行组建'}]">
                </my-radio>
            </el-form-item>

            <el-form-item
            label="交易中心"
            prop="jyzx">
                {{form.jyzx}}
            </el-form-item>

           <el-form-item
            label="评标室"
            prop="bidevaluation_room"
            :rules="newRule('评标室', 'required')">
                <el-input
                    v-model="form.bidevaluation_room">
                </el-input>
            </el-form-item> 

            <my-form-item-group title="请填写以下内容，用于生成评标报告"  v-if="form.typbzjk==='1'">
            <el-form-item
            label="抽取时间"
            prop="pstime"
            :rules="newRule('抽取时间', 'required')">
                <el-date-picker
                v-model="form.cqtime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                >
                </el-date-picker>
            </el-form-item>
             
            <el-form-item
            label="抽取地点"
            prop="cqdd"
            :rules="newRule('抽取地点', 'required')">
                <el-input
                    v-model="form.cqdd">
                </el-input>
            </el-form-item>

            <el-form-item
            label="抽取人"
            prop="cqjdr"
            :rules="newRule('抽取人', 'required')" >
                <el-input
                    v-model="form.cqjdr">
                </el-input>
            </el-form-item>
      
            <el-form-item
            label="招标人抽取代表"
            prop="cqzbrdb"
            :rules="newRule('招标人抽取代表', 'required')" >
                <el-input
                    v-model="form.cqzbrdb">
                </el-input>
            </el-form-item>
            </my-form-item-group>
             
            <template slot="btn" slot-scope="scope">
                <el-button
                    @click="saveHandler(1, scope.submitHandler)"
                    type="primary"
                    icon="el-icon-circle-check">
                        保存
                </el-button>
                <el-button
                    @click="saveHandler(0, scope.submitHandler)"
                    type="warning"
                    icon="el-icon-remove-outline">
                        暂存
                </el-button>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>
    </div>
</template>
 
<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import CascaderBid from './components/cascader-bid'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { CascaderBid },
    data: () => ({
        form: {},
        isnzk:'',
        ptPlaceholder: window._config.title2,
    }),                                                                                                      
    methods: {
        saveHandler(type, cb) {
            this.form.shbj = type;
            cb && cb();
        },
        submitHandler:function(){
            var that=this;
            this.form.zgys = this.getQuery('zgys');
            if(this.isnzk===false){
                that.$post(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/add.json`,this.form,(data, res) => {
                    if (res.result) {
                        ShowMsg(res.msg,'success')
                        this.cancleHandler();
                    } else {
                        ShowMsg(res.msg)
                    }
                });
            }
            if(this.isnzk===true) {
                that.$post(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/nzkadd.json`,this.form,(data, res) => {
                    if (res.result) {
                        ShowMsg(res.msg,'success')
                          this.cancleHandler();
                    } else {
                        ShowMsg(res.msg)
                    }
                });
            }
        },                                                                                                                         
    },
    created() {
        this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/edit.json`,
        {   
           zgys:this.getQuery('zgys'),
           procode:this.getQuery('procode'),
           id:this.getQuery('id'),
        }
        , data => {
            var model = data.model;
            model.jyzx = data.jyzx;
            model.shuliang = data.sum;
            model.procode=data.procode;
            this.form = model;
            this.isnzk=data.isnzk
            
            this.jspDataInit(data, []);
        });
    }
}
</script>

<style scoped lang="scss">
.tip {
    margin-top: 50px;
}
</style>
